function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App, { AlertsBus } from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../ModalCommon.pcss';
var _React_PureComponent;
class RevokeFamilyAccessModal extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress !== state.isInProgress && isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProp) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProp.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onClose();
        }
    }
    async onClose() {
        await this.props.onCloseModal();
        this.props.onClearForm();
        this.setState({
            isInProgress: true
        });
    }
    onRevokeAccess() {
        const familyLink = get(this.props.formValues, 'contextData');
        this.props.onRevoke(familyLink);
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "modal__actions row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "quaternary",
                        labelMessage: messages.buttons.noKeepAccess,
                        className: "btn--block",
                        onClick: ()=>this.onClose()
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.revokeAccess,
                        className: "btn--block btn--filled",
                        isInProgress: this.state.isInProgress,
                        onClick: ()=>this.onRevokeAccess()
                    })
                })
            ]
        });
    }
    renderPerson() {
        const familyLink = get(this.props.formValues, 'contextData');
        const { avatar, firstName, lastName } = get(familyLink, 'requestor', {});
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('row align-items-center', styles.person),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: avatar,
                        name: [
                            firstName,
                            lastName
                        ],
                        className: styles.item__avatar,
                        imgClassName: styles.item__avatar__img,
                        initialsClassName: styles.item__avatar__initials
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsxs("p", {
                        className: styles.person__name,
                        children: [
                            firstName,
                            " ",
                            lastName
                        ]
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.REVOKE_FAMILY_ACCESS_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            headerMessage: messages.headers.revokeAccess,
            onClose: this.props.onCloseModal,
            children: [
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-4"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.container,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.areYouSureToRevokeAccess), {
                        values: {
                            person: this.renderPerson()
                        }
                    }))
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
    }
}
_define_property(RevokeFamilyAccessModal, "propTypes", {
    // Implicit props
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    formValues: PropTypes.object,
    openModalId: PropTypes.string,
    // Implicit actions
    onRevoke: PropTypes.func,
    onCloseModal: PropTypes.func,
    onClearForm: PropTypes.func
});
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.REVOKE_FAMILY_ACCESS_FORM)(state),
        openModalId: App.selectors.modal(state),
        isInProgress: selectors.isRevokeFamilyAccessInProgress(state),
        hasErrors: selectors.hasRevokeFamilyAccessErrors(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onRevoke: (familyLink)=>dispatch(actions.revokeFamilyAccess(familyLink)),
        onCloseModal: ()=>dispatch(App.actions.closeModal()),
        onClearForm: ()=>dispatch(App.actions.clearForm(constants.REVOKE_FAMILY_ACCESS_FORM))
    });
const ConnectedRevokeFamilyAccessModal = connect(mapStateToProps, mapDispatchToProps)(RevokeFamilyAccessModal);
export default withStyles(styles)(ConnectedRevokeFamilyAccessModal);
